{
  "latitude": 55.6785,
  "longitude": 12.570435,
  "generationtime_ms": 0.0528097152709961,
  "utc_offset_seconds": 3600,
  "timezone": "Europe/Copenhagen",
  "timezone_abbreviation": "GMT+1",
  "elevation": 11,
  "current_units": {
    "time": "iso8601",
    "interval": "seconds",
    "wind_speed_10m": "km/h",
    "wind_direction_10m": "°",
    "wind_gusts_10m": "km/h"
  },
  "current": {
    "time": "2025-02-07T20:15",
    "interval": 900,
    "wind_speed_10m": 20.9,
    "wind_direction_10m": 86,
    "wind_gusts_10m": 40.7
  },
  "hourly_units": {
    "time": "iso8601",
    "wind_speed_10m": "km/h",
    "wind_direction_10m": "°",
    "wind_gusts_10m": "km/h"
  },
  "hourly": {
    "time": [
      "2025-01-31T00:00",
      "2025-01-31T01:00",
      "2025-01-31T02:00",
      "2025-01-31T03:00",
      "2025-01-31T04:00",
      "2025-01-31T05:00",
      "2025-01-31T06:00",
      "2025-01-31T07:00",
      "2025-01-31T08:00",
      "2025-01-31T09:00",
      "2025-01-31T10:00",
      "2025-01-31T11:00",
      "2025-01-31T12:00",
      "2025-01-31T13:00",
      "2025-01-31T14:00",
      "2025-01-31T15:00",
      "2025-01-31T16:00",
      "2025-01-31T17:00",
      "2025-01-31T18:00",
      "2025-01-31T19:00",
      "2025-01-31T20:00",
      "2025-01-31T21:00",
      "2025-01-31T22:00",
      "2025-01-31T23:00",
      "2025-02-01T00:00",
      "2025-02-01T01:00",
      "2025-02-01T02:00",
      "2025-02-01T03:00",
      "2025-02-01T04:00",
      "2025-02-01T05:00",
      "2025-02-01T06:00",
      "2025-02-01T07:00",
      "2025-02-01T08:00",
      "2025-02-01T09:00",
      "2025-02-01T10:00",
      "2025-02-01T11:00",
      "2025-02-01T12:00",
      "2025-02-01T13:00",
      "2025-02-01T14:00",
      "2025-02-01T15:00",
      "2025-02-01T16:00",
      "2025-02-01T17:00",
      "2025-02-01T18:00",
      "2025-02-01T19:00",
      "2025-02-01T20:00",
      "2025-02-01T21:00",
      "2025-02-01T22:00",
      "2025-02-01T23:00",
      "2025-02-02T00:00",
      "2025-02-02T01:00",
      "2025-02-02T02:00",
      "2025-02-02T03:00",
      "2025-02-02T04:00",
      "2025-02-02T05:00",
      "2025-02-02T06:00",
      "2025-02-02T07:00",
      "2025-02-02T08:00",
      "2025-02-02T09:00",
      "2025-02-02T10:00",
      "2025-02-02T11:00",
      "2025-02-02T12:00",
      "2025-02-02T13:00",
      "2025-02-02T14:00",
      "2025-02-02T15:00",
      "2025-02-02T16:00",
      "2025-02-02T17:00",
      "2025-02-02T18:00",
      "2025-02-02T19:00",
      "2025-02-02T20:00",
      "2025-02-02T21:00",
      "2025-02-02T22:00",
      "2025-02-02T23:00",
      "2025-02-03T00:00",
      "2025-02-03T01:00",
      "2025-02-03T02:00",
      "2025-02-03T03:00",
      "2025-02-03T04:00",
      "2025-02-03T05:00",
      "2025-02-03T06:00",
      "2025-02-03T07:00",
      "2025-02-03T08:00",
      "2025-02-03T09:00",
      "2025-02-03T10:00",
      "2025-02-03T11:00",
      "2025-02-03T12:00",
      "2025-02-03T13:00",
      "2025-02-03T14:00",
      "2025-02-03T15:00",
      "2025-02-03T16:00",
      "2025-02-03T17:00",
      "2025-02-03T18:00",
      "2025-02-03T19:00",
      "2025-02-03T20:00",
      "2025-02-03T21:00",
      "2025-02-03T22:00",
      "2025-02-03T23:00",
      "2025-02-04T00:00",
      "2025-02-04T01:00",
      "2025-02-04T02:00",
      "2025-02-04T03:00",
      "2025-02-04T04:00",
      "2025-02-04T05:00",
      "2025-02-04T06:00",
      "2025-02-04T07:00",
      "2025-02-04T08:00",
      "2025-02-04T09:00",
      "2025-02-04T10:00",
      "2025-02-04T11:00",
      "2025-02-04T12:00",
      "2025-02-04T13:00",
      "2025-02-04T14:00",
      "2025-02-04T15:00",
      "2025-02-04T16:00",
      "2025-02-04T17:00",
      "2025-02-04T18:00",
      "2025-02-04T19:00",
      "2025-02-04T20:00",
      "2025-02-04T21:00",
      "2025-02-04T22:00",
      "2025-02-04T23:00",
      "2025-02-05T00:00",
      "2025-02-05T01:00",
      "2025-02-05T02:00",
      "2025-02-05T03:00",
      "2025-02-05T04:00",
      "2025-02-05T05:00",
      "2025-02-05T06:00",
      "2025-02-05T07:00",
      "2025-02-05T08:00",
      "2025-02-05T09:00",
      "2025-02-05T10:00",
      "2025-02-05T11:00",
      "2025-02-05T12:00",
      "2025-02-05T13:00",
      "2025-02-05T14:00",
      "2025-02-05T15:00",
      "2025-02-05T16:00",
      "2025-02-05T17:00",
      "2025-02-05T18:00",
      "2025-02-05T19:00",
      "2025-02-05T20:00",
      "2025-02-05T21:00",
      "2025-02-05T22:00",
      "2025-02-05T23:00",
      "2025-02-06T00:00",
      "2025-02-06T01:00",
      "2025-02-06T02:00",
      "2025-02-06T03:00",
      "2025-02-06T04:00",
      "2025-02-06T05:00",
      "2025-02-06T06:00",
      "2025-02-06T07:00",
      "2025-02-06T08:00",
      "2025-02-06T09:00",
      "2025-02-06T10:00",
      "2025-02-06T11:00",
      "2025-02-06T12:00",
      "2025-02-06T13:00",
      "2025-02-06T14:00",
      "2025-02-06T15:00",
      "2025-02-06T16:00",
      "2025-02-06T17:00",
      "2025-02-06T18:00",
      "2025-02-06T19:00",
      "2025-02-06T20:00",
      "2025-02-06T21:00",
      "2025-02-06T22:00",
      "2025-02-06T23:00",
      "2025-02-07T00:00",
      "2025-02-07T01:00",
      "2025-02-07T02:00",
      "2025-02-07T03:00",
      "2025-02-07T04:00",
      "2025-02-07T05:00",
      "2025-02-07T06:00",
      "2025-02-07T07:00",
      "2025-02-07T08:00",
      "2025-02-07T09:00",
      "2025-02-07T10:00",
      "2025-02-07T11:00",
      "2025-02-07T12:00",
      "2025-02-07T13:00",
      "2025-02-07T14:00",
      "2025-02-07T15:00",
      "2025-02-07T16:00",
      "2025-02-07T17:00",
      "2025-02-07T18:00",
      "2025-02-07T19:00",
      "2025-02-07T20:00",
      "2025-02-07T21:00",
      "2025-02-07T22:00",
      "2025-02-07T23:00"
    ],
    "wind_speed_10m": [13.3, 12.6, 12.6, 12.2, 12.2, 10.1, 7.9, 9.4, 6.5, 7.2, 9.4, 10.4, 10.4, 10.8, 11.9, 13.7, 14.4, 14.4, 13.7, 14, 10.4, 8.3, 8.3, 8.3, 9, 9, 9.7, 8.3, 8.6, 7.2, 5.8, 3.6, 2.9, 4, 5.4, 5, 4.3, 4, 4, 3.2, 5.8, 5.4, 3.2, 3.2, 5.8, 5.4, 6.1, 5.8, 4, 4, 4.7, 5, 2.5, 1.8, 4.7, 5, 5.4, 5.4, 5.4, 8.3, 8.3, 7.2, 7.9, 7.9, 7.6, 9, 10.1, 11.9, 10.4, 9.7, 9, 8.6, 11.9, 11.2, 10.4, 8.6, 8.6, 7.9, 9, 8.3, 6.5, 6.8, 7.2, 7.6, 6.8, 7.9, 9.7, 9, 10.8, 8.3, 8.6, 9.4, 8.6, 10.1, 9.4, 9, 6.5, 6.8, 5.4, 7.2, 7.2, 9.7, 9.7, 11.2, 11.2, 11.9, 13.3, 12.6, 11.9, 13.3, 13, 13, 14.4, 13.3, 13.3, 15.1, 16.2, 17.6, 17.3, 17.6, 16.6, 15.8, 15.5, 15.8, 21.2, 20.2, 19.4, 19.8, 18.4, 16.9, 18, 16.9, 16.9, 20.2, 21.2, 18.7, 19.8, 14.4, 13, 15.1, 9.7, 8.6, 9.7, 9.7, 9.7, 10.8, 10.8, 10.8, 11.9, 11.5, 9.7, 8.3, 8.6, 7.6, 8.3, 9, 13.3, 11.9, 12.2, 13, 10.1, 9.4, 9.7, 10.4, 10.8, 9.7, 9, 7.9, 7.6, 8.3, 7.9, 10.1, 10.1, 12.6, 15.5, 16.2, 15.1, 16.9, 18, 15.8, 17.3, 18, 18.7, 18.4, 23, 24.1, 25.6, 22.3, 21.2, 19.1, 18.4, 19.8],
    "wind_direction_10m": [269, 270, 267, 268, 274, 266, 248, 250, 242, 250, 258, 286, 302, 294, 283, 280, 295, 305, 305, 309, 301, 296, 290, 283, 285, 290, 286, 285, 282, 287, 292, 293, 277, 248, 304, 323, 57, 48, 48, 43, 48, 35, 341, 330, 356, 348, 321, 327, 303, 300, 323, 307, 317, 187, 230, 246, 243, 232, 232, 247, 253, 272, 279, 275, 269, 272, 277, 280, 284, 270, 268, 263, 274, 281, 274, 255, 260, 247, 249, 252, 240, 221, 242, 238, 230, 203, 192, 186, 188, 184, 182, 212, 210, 214, 242, 245, 236, 215, 221, 248, 214, 225, 226, 232, 209, 216, 220, 233, 224, 218, 221, 213, 213, 216, 221, 212, 207, 210, 214, 211, 208, 211, 213, 218, 227, 222, 220, 233, 239, 237, 239, 248, 261, 277, 286, 283, 285, 281, 285, 282, 285, 274, 278, 283, 288, 284, 283, 290, 291, 299, 301, 305, 310, 320, 11, 3, 10, 15, 23, 18, 6, 7, 22, 57, 51, 50, 63, 87, 97, 77, 58, 65, 89, 94, 93, 85, 58, 66, 58, 59, 61, 62, 64, 66, 67, 60, 72, 74, 86, 89, 116, 101],
    "wind_gusts_10m": [24.8, 24.1, 24.8, 23.4, 22.7, 22.7, 16.9, 16.2, 15.8, 12.6, 18.7, 21.6, 22.7, 24.1, 24.5, 26.3, 28.1, 28.1, 27.4, 26.6, 26.6, 18.7, 15.8, 14, 15.8, 18.7, 17.6, 18, 15.8, 16.2, 13.7, 11.9, 7.2, 7.9, 13.3, 13, 10.8, 10.4, 10.1, 9.4, 10.8, 11.5, 10.4, 7.6, 11.9, 12.6, 11.9, 12.2, 10.1, 10.8, 10.4, 11.9, 11.5, 5.8, 8.6, 10.4, 10.8, 11.2, 11.5, 16.6, 17.3, 15.5, 16.9, 16.6, 16.9, 17.3, 19.1, 26.6, 22.7, 19.8, 16.6, 15.8, 22.3, 24.8, 21.6, 20.2, 18.7, 16.6, 16.6, 16.9, 15.8, 14, 16.6, 16.9, 18, 17.6, 20.5, 20.5, 23.4, 20.2, 15.5, 17.3, 17.6, 18, 18.7, 17.3, 15.5, 12.6, 10.8, 17.3, 15.1, 18.4, 18.4, 21.6, 22, 24.5, 26.6, 27, 25.6, 27, 27.7, 26.3, 27.4, 27.4, 25.9, 29.2, 31.3, 33.5, 35.3, 34.9, 33.1, 32.4, 29.9, 30.2, 41, 40.3, 38.9, 38.9, 37.4, 34.6, 37.1, 35.6, 34.9, 41, 42.8, 43.6, 39.6, 37.8, 27, 32, 28.1, 18.7, 19.4, 18.4, 18, 19.8, 20.2, 20.2, 22, 22, 21.2, 17.6, 14.4, 14.4, 17.3, 18.7, 27, 24.8, 24.8, 27, 26.3, 19.4, 16.6, 17.3, 20.2, 18, 16.2, 15.5, 14.8, 15.8, 15.8, 18.7, 19.4, 24.1, 29.2, 30.6, 30.2, 31.7, 34.2, 33.8, 34.6, 35.3, 39.6, 39.2, 43.6, 45, 47.9, 47.9, 41.4, 40, 42.5, 39.6]
  },
  "daily_units": {
    "time": "iso8601",
    "wind_speed_10m_max": "km/h",
    "wind_gusts_10m_max": "km/h",
    "wind_direction_10m_dominant": "°"
  },
  "daily": {
    "time": [
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07"
    ],
    "wind_speed_10m_max": [14.4, 9.7, 11.9, 11.9, 17.6, 21.2, 13.3, 25.6],
    "wind_gusts_10m_max": [28.1, 18.7, 26.6, 24.8, 35.3, 43.6, 27, 47.9],
    "wind_direction_10m_dominant": [281, 317, 269, 231, 218, 251, 351, 75]
  }
}